import styles from './IppicaQuoteFinaliResultsContainer.module.scss';
import { useTypedSelector } from 'lib/centralStore';
import { selectQuotaFinaleByCodiceTipoScommessa, selectTitleByCodiceTipoScommessa } from 'features/ippica/selectors';

export type QuoteFinaliResultsContainerProps = {
  codiceTipoScommessa: number;
};
export const IppicaQuoteFinaliResultsContainer = ({ codiceTipoScommessa }: QuoteFinaliResultsContainerProps) => {
  const title = useTypedSelector((state) => selectTitleByCodiceTipoScommessa(state, codiceTipoScommessa));
  const quotaFinale = useTypedSelector((state) => selectQuotaFinaleByCodiceTipoScommessa(state, codiceTipoScommessa));

  return (
    <div className={styles.container}>
      {title && <p className={styles.title}>{title}</p>}
      {quotaFinale?.map((singleQuota, index) => {
        const { combinazione, quota } = singleQuota;
        return (
          <p key={combinazione + '_' + index} className={`${styles.row} ${!combinazione ? styles.centered : ''}`}>
            {combinazione && <span className={styles.text}>{combinazione}</span>}
            <span className={styles.quota}>{quota}</span>
          </p>
        );
      })}
    </div>
  );
};
